import React, { useEffect, useState } from 'react';
import { Grid, Typography, Paper, Divider, Container } from '@mui/material';
import { Copyright } from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import SocialMedia from './SocialMedia';
import Leaflet from '../map/Leaflet';
import QuickLinks from './QuickLinks';

const StyledPaper = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '' : 'darkgray',
}));

const StyledLink = styled(Link)(({ linkColor }) => ({
  textDecoration: 'none',
  display: 'block',
  color: linkColor,
  transition: 'color 0.3s',
  '&:hover': { color: 'teal', marginLeft: 2 },
}));

export default function Footer({ containerRef }) {
  const customLat = 9.67958;
  const customLong = 39.532575;
  const customZoom = 10;

  const [color1] = useState('#3e4244');
  const [color2] = useState('#a9a9a9');
  const [currentColor, setCurrentColor] = useState(color1);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentColor((prevColor) => (prevColor === color1 ? color2 : color1));
    }, 1000);

    return () => clearInterval(intervalId);
  }, [color1, color2]);

  return (
    <>
      <Container maxWidth="xs">
        <Divider sx={{ mt: 5, mb: 1 }} />
        <Divider />
        <Divider gutterBottom sx={{ mb: 10, mt: 1 }} />
      </Container>

      <StyledPaper
        sx={{
          borderTopLeftRadius: { xs: '1%', md: '3%' },
          borderTopRightRadius: { xs: '1%', md: '3%' },
        }}
      >
        <Grid container spacing={3} sx={{ p: { xs: 1, md: 5 } }}>
          <Grid item xs={12} sm={8} md={4} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Leaflet fullWidth lat={customLat} long={customLong} zoom={customZoom} />
          </Grid>{' '}
          <Grid item xs={12} sm={4} md={4} sx={{ display: 'flex', justifyContent: 'center' }}>
            <QuickLinks containerRef={containerRef} title="ፈጣን ማገናኛዎች" subheader="ፈጣን ማገናኛዎች እና ተጨማሪ ሳይቶቻችንን ያግኙ።" />
          </Grid>{' '}
          <Grid item xs={12} sm={12} md={4} sx={{ display: 'block' }}>
            <SocialMedia title="ማኅበራዊ ሚዲያ" subheader="በነዚህ ማህበይራዊ ሚዲያዎውች አብረውን ይሁኑ።" />
          </Grid>
          <Grid item sx={12} sm={12}>
            <Divider sx={{ p: 2, pt: 0, pb: 0, fontSize: 24 }} />
            <Typography
              variant="body2"
              sx={{
                p: 2,
                textAlign: 'center',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'text.secondary',
              }}
            >
              <Copyright sx={{ verticalAlign: 'middle' }} /> አቡቀለምሲስ : ኢትዮጵያ ፣ አማራ ፣ ሰሜን ሸዋ ፣ ደብረ ብርሃን | MGHM+R2W, Debre
              Birhan
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: 'darkgray',
                display: { xs: 'none', md: 'flex' },
                justifyContent: 'right',
                mt: -4,
              }}
            >
              <StyledLink
                to="https://belaybirhanu.netlify.app/"
                linkColor={currentColor}
                target="_blank"
                rel="noopener noreferrer"
              >
                ?
              </StyledLink>
            </Typography>
          </Grid>
        </Grid>
      </StyledPaper>
    </>
  );
}

Footer.propTypes = {
  containerRef: PropTypes.object,
};
